import { render, staticRenderFns } from "./CrearTipoDatoExtendidoModal.vue?vue&type=template&id=1c02be45&scoped=true&"
import script from "./CrearTipoDatoExtendidoModal.vue?vue&type=script&lang=ts&"
export * from "./CrearTipoDatoExtendidoModal.vue?vue&type=script&lang=ts&"
import style0 from "./CrearTipoDatoExtendidoModal.vue?vue&type=style&index=0&id=1c02be45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c02be45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c02be45', component.options)
    } else {
      api.reload('1c02be45', component.options)
    }
    module.hot.accept("./CrearTipoDatoExtendidoModal.vue?vue&type=template&id=1c02be45&scoped=true&", function () {
      api.rerender('1c02be45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dispositivos/CrearTipoDatoExtendidoModal.vue"
export default component.exports